var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1309 16.166C30.1309 20.5757 26.6292 24.1504 22.3096 24.1504C17.99 24.1504 14.4883 20.5757 14.4883 16.166C14.4883 11.7564 17.99 8.18164 22.3096 8.18164C26.6292 8.18164 30.1309 11.7564 30.1309 16.166Z",
    stroke: "#710D10",
    strokeWidth: 3.54041,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7123 15.5384H44.4025M44.4025 15.5384H39.0928M44.4025 15.5384V20.9587M44.4025 15.5384V10.1177",
    stroke: "#710D10",
    strokeWidth: 3.03415,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0913 31.2271C26.1286 31.2271 29.6968 32.1783 32.1948 33.6245C34.7388 35.0974 35.8638 36.8681 35.8638 38.4546C35.8638 40.0411 34.7388 41.8118 32.1948 43.2847C29.6968 44.7308 26.1286 45.6821 22.0913 45.6821C18.0538 45.6821 14.485 44.7309 11.9868 43.2847C9.44279 41.8118 8.31787 40.0411 8.31787 38.4546C8.31787 36.8681 9.44279 35.0974 11.9868 33.6245C14.485 32.1783 18.0538 31.2271 22.0913 31.2271Z",
    stroke: "#710D10",
    strokeWidth: 3.54471
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUserIcon);
export default __webpack_public_path__ + "static/media/follow-user-icon.b0a91afa13f1378d1c50f15c1965eb53.svg";
export { ForwardRef as ReactComponent };